import type { IServicesCollection } from 'src/packages/di';

import { GeneratedUserFilesService } from './GeneratedUserFilesService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    generatedUserFilesService: GeneratedUserFilesService;
  }
}

export function addGeneratedUserFilesService(di: IServicesCollection) {
  const generatedUserFilesService = new GeneratedUserFilesService();

  di.addSingleton('generatedUserFilesService', generatedUserFilesService);
}
